<div class="lookupfilter-body" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
  <div class="spinner-container" *ngIf="isLoading">
    <p-progress-spinner></p-progress-spinner>
  </div>
  <div class="section-table-container lookup-tbl">
    <p-table
      [value]="queryMapping"
      class="fil-map-table"
      [showGridlines]="true"
      [style]="{ width: '100%' }"
      [scrollable]="true"
      *ngIf="element.lookupTo === 'queryMapMandParams' || element.lookupTo === 'queryMapDetParams'"
    >
      <ng-template #header>
        <tr>
          <th>{{ colHeader1 | translate }}</th>
          <th></th>
          <th class="type-col" *ngIf="element?.name === 'queryViewMapping'">{{ 'TYPE' | translate }}</th>
          <th>{{ colHeader2 | translate }}</th>
          <th *ngIf="element?.name === 'queryViewMapping'" class="p-0"></th>
        </tr>
      </ng-template>
      <ng-template #body let-data let-rowIndex="rowIndex">
        <tr>
          <td>
            <span
              tooltipPosition="top"
              showDelay="100"
              hideDelay="100"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="{{ data.lookupField.name }}"
              >{{ data.lookupField.name }}</span
            >
          </td>
          <td class="arrow-denotation">
            <i class="pi pi-arrow-left"></i>
          </td>
          <td *ngIf="element?.name === 'queryViewMapping'" class="type-col">
            <div class="d-flex align-items-center param-map-type form-group prop-elems p-0">
              <p-select
                [(ngModel)]="data.type"
                [disabled]="disableField"
                [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                [options]="
                  data?.lookupField?.f_type === 'Date' || data?.lookupField?.f_type === 'DateTime'
                    ? typeOptionsForDate
                    : typeOptions
                "
                optionLabel="name"
                (onChange)="onTypeValueChange($event, rowIndex)"
                appendTo="body"
                [emptyMessage]="'No records found'"
                placeholder="Select"
                class="w-100"
              >
              </p-select>
            </div>
          </td>
          <td class="td-mapping-field">
            <div
              class="d-flex align-items-center query-map-auto position-relative"
              *ngIf="element.name === 'queryViewMapping'"
            >
              <ng-container
                *ngIf="
                  !data.type || (data.type && (data.type?.value === 'field' || data?.type?.value === 'pageVariable'))
                "
              >
                <div class="autocomplete-wrapper">
                <p-autocomplete
                  [(ngModel)]="data.tableField"
                  dataKey="sid"
                  [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                  showDelay="100"
                  hideDelay="100"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  pTooltip="{{ data.tableField ? data.tableField.name : null }}"
                  [suggestions]="allFieldsFiltered"
                  (onSelect)="onfieldSel($event, ri)"
                  trim="blur"
                  appendTo="body"
                  [showEmptyMessage]="true"
                  (completeMethod)="showFilteredOptions($event, data)"
                  [dropdown]="true"
                  [forceSelection]="true"
                  field="name"
                  placeholder="Select"
                  panelStyleClass="group-autocomplete"
                  [disabled]="data?.tableField?.fromParamMapping"
                  [emptyMessage]="'No records found'"
                [class.warnings-border]="isQueryMappingFieldMismatch(data)"
                [class.errors-borders]="isQueryMappingFieldNoLonger(data)"
                >
                  <ng-template let-field pTemplate="item">
                    <div class="field-item text-overflow">
                      <span>{{ field.name }}</span>
                    </div>
                  </ng-template>
                  <ng-template let-group #group>
                    <div class="flex align-items-center">
                      <span class="fw-bold">{{ group.name }}</span>
                    </div>
                  </ng-template>
                </p-autocomplete>
                <i
                  *ngIf="isQueryMappingFieldMismatch(data)"
                  class="pi pi-exclamation-triangle warn-icon"
                  (click)="toggleErrorPopup(ri, 'warning')"
                  (keyup.enter)="toggleErrorPopup(ri, 'warning')"
                  tabindex="0"
                ></i>
                <i
                  *ngIf="isQueryMappingFieldNoLonger(data)"
                  class="pi pi-exclamation-circle errors-icon"
                  (click)="toggleErrorPopup(ri, 'error')"
                  (keyup.enter)="toggleErrorPopup(ri, 'error')"
                  tabindex="0"
                ></i>
                <span
                  class="pi pi-times cursor-pointer ml-1 crossed-icon"
                  (click)="onRowDelete(rowIndex)"
                  (keyup.enter)="onRowDelete(rowIndex)"
                  tabindex="0"
                  aria-label="Row delete"
                  *ngIf="data.tableField && !data?.tableField?.fromParamMapping"
                ></span>
              </div>
              </ng-container>
              <ng-container *ngIf="data.type && data.type?.value === 'value'">
                <ng-container [ngSwitch]="data.lookupField.f_type">
                  <ng-template
                    [ngSwitchCase]="
                      ['String', 'Email', 'Color', 'URL'].includes(data.lookupField.f_type)
                        ? data.lookupField.f_type
                        : null
                    "
                  >
                    <input
                      [name]="element.name"
                      [attr.id]="element.name"
                      type="text"
                      class="form-control form-control-sm"
                      [(ngModel)]="data.staticValue"
                      (focusout)="onValueChange($event)"
                      [disabled]="disableField"
                    />
                  </ng-template>
                  <ng-template
                    [ngSwitchCase]="
                      ['Auto-number', 'Number'].includes(data.lookupField.f_type) ? data.lookupField.f_type : null
                    "
                  >
                    <p-inputNumber
                      [(ngModel)]="data.staticValue"
                      class="form-control form-control-sm"
                      [attr.id]="element.name"
                      (onBlur)="onValueChange($event)"
                      maxlength="16"
                      [disabled]="disableField"
                    ></p-inputNumber>
                  </ng-template>
                  <ng-template
                    [ngSwitchCase]="
                      ['Currency', 'Double'].includes(data.lookupField.f_type) ? data.lookupField.f_type : null
                    "
                  >
                    <p-inputNumber
                      [(ngModel)]="data.staticValue"
                      class="form-control form-control-sm"
                      [disabled]="disableField"
                      mode="decimal"
                      [attr.id]="element.name"
                      (onBlur)="onValueChange($event)"
                      maxlength="16"
                      [minFractionDigits]="data.lookupField.f_minFrac"
                      [maxFractionDigits]="data.lookupField.f_maxFrac"
                    ></p-inputNumber>
                  </ng-template>
                  <ng-template
                    [ngSwitchCase]="
                      ['Checkbox', 'Boolean'].includes(data.lookupField.f_type) ? data.lookupField.f_type : null
                    "
                  >
                    <p-checkbox
                      [binary]="true"
                      [inputId]="element.name"
                      [name]="element.name"
                      [disabled]="disableField"
                      [attr.id]="element.name"
                      styleClass="mt-2"
                      [(ngModel)]="data.staticValue"
                      (onChange)="onValueChange($event)"
                    ></p-checkbox>
                  </ng-template>
                  <ng-template [ngSwitchCase]="'Text'">
                    <textarea
                      pTextarea
                      [(ngModel)]="data.staticValue"
                      [attr.id]="element.name"
                      class="form-control form-control-sm"
                      [rows]="1"
                      autoResize="autoResize"
                      (input)="onValueChange($event)"
                      [disabled]="disableField"
                    ></textarea>
                  </ng-template>
                  <ng-template
                    [ngSwitchCase]="
                      ['Dropdown', 'Radio'].includes(data.lookupField.f_type) ? data.lookupField.f_type : null
                    "
                  >
                    <vb-dynamic-dropdown
                      [options]="data.dynamicOptions"
                      [element]="element"
                      class="flex-grow-1"
                      [(ngModel)]="data.staticValue"
                      [disableField]="disableField"
                      [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                      (valChanges)="onValueChange($event)"
                    >
                    </vb-dynamic-dropdown>
                  </ng-template>
                  <ng-template
                    [ngSwitchCase]="
                      ['Date', 'DateTime'].includes(data.lookupField.f_type) ? data.lookupField.f_type : null
                    "
                  >
                    <p-select
                      [options]="dateOptions"
                      [(ngModel)]="data.staticValue"
                      class="flex-grow-1"
                      placeholder="Select"
                      appendTo="body"
                      [disabled]="disableField"
                      [showClear]="true"
                      (onChange)="onValueChange($event)"
                      optionLabel="label"
                      optionValue="value"
                    >
                    </p-select>
                  </ng-template>
                  <ng-template [ngSwitchCase]="'Yes No'">
                    <p-select
                      [options]="ynOptions"
                      [(ngModel)]="data.staticValue"
                      class="flex-grow-1"
                      optionLabel="name"
                      placeholder="Select"
                      [disabled]="disableField"
                      optionValue="value"
                      (onChange)="onValueChange($event)"
                      [appendTo]="'body'"
                    >
                    </p-select>
                  </ng-template>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="data.type && (data.type?.value === 'plusDays' || data.type?.value === 'minusDays')">
                <p-inputNumber
                  [(ngModel)]="data.staticValue"
                  class="form-control form-control-sm"
                  [attr.id]="element.name"
                  (onBlur)="set()"
                  maxlength="6"
                  [min]="1"
                  [useGrouping]="false"
                  [disabled]="disableField"
                ></p-inputNumber>
              </ng-container>
            </div>
            <div
              class="d-flex align-items-center"
              *ngIf="element.name === 'detailPageMapping' || this.element.lookupTo === 'queryMapDetParams'"
            >
              <div class="autocomplete-wrapper">
              <p-autocomplete
                [(ngModel)]="data.tableField"
                dataKey="sid"
                tooltipPosition="top"
                showDelay="100"
                hideDelay="100"
                tooltipStyleClass="label-tooltip custom-tooltip-properties"
                pTooltip="{{ data?.tableField ? data?.tableField?.name : null }}"
                [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                [suggestions]="allFieldsFiltered"
                (onSelect)="onfieldSel($event, ri)"
                trim="blur"
                appendTo="body"
                [showEmptyMessage]="true"
                (completeMethod)="showFilteredOptions($event, data)"
                [dropdown]="true"
                panelStyleClass="group-autocomplete"
                [forceSelection]="true"
                field="name"
                placeholder="Select"
                [group]="true"
                [emptyMessage]="'No records found'"
                [class.warnings-border]="isQueryMappingFieldMismatch(data)"
                [class.errors-borders]="isQueryMappingFieldNoLonger(data)"
              >
                <ng-template let-field pTemplate="item">
                  <div class="field-item text-overflow">
                    <span>{{ field.name }}</span>
                  </div>
                </ng-template>
                <ng-template let-group #group>
                  <div class="flex align-items-center">
                    <span class="fw-bold">{{ group.name }}</span>
                  </div>
                </ng-template>
              </p-autocomplete>
              <i
                  *ngIf="isQueryMappingFieldMismatch(data)"
                  class="pi pi-exclamation-triangle warnings-qv-icon"
                  (click)="toggleErrorPopup(ri, 'warning')"
                  (keyup.enter)="toggleErrorPopup(ri, 'warning')"
                  tabindex="0"
                ></i>
                <i
                  *ngIf="isQueryMappingFieldNoLonger(data)"
                  class="pi pi-exclamation-circle errors-icon"
                  (click)="toggleErrorPopup(ri, 'error')"
                  (keyup.enter)="toggleErrorPopup(ri, 'error')"
                  tabindex="0"
                ></i>
              <span
                class="pi pi-times cursor-pointer ml-1 crossed-icon"
                (click)="onRowDelete(rowIndex)"
                (keyup.enter)="onRowDelete(rowIndex)"
                tabindex="1"
                aria-label="Row Delete"
                *ngIf="data.tableField"
              ></span>
              </div>
            </div>
          </td>
          <td class="text-center p-0" *ngIf="element?.name === 'queryViewMapping'">
            <div class="param-actions" *ngIf="!disableField">
              <svg-icon
                (click)="openOption(data)"
                src="assets\images\svg\edit.svg"
                class="icon-plus cursor-pointer mr-1"
                alt="edit"
                aria-hidden="true"
                showDelay="100"
                hideDelay="100"
                pTooltip="Edit"
                tooltipPosition="top"
              ></svg-icon>
            </div>
          </td></tr>
          <div *ngIf="activePopupIndex === ri && popupType === 'warning'" class="warning-popups">
                  <div class="popup-header">
                    Warning
                  </div>
                  <div class="popup-content">{{ 'FLD_MISMATCH' | translate }}</div>
                  <button class="close-btn" (click)="closePopup()">×</button>
              </div>
              <div *ngIf="activePopupIndex === ri && popupType === 'error'" class="warning-popups-errors">
                <div class="popup-header-errors">
                  Error
                </div>
                <div class="popup-content-errors">{{ 'FLD_NO_LONGER' | translate }}</div>
                <button class="close-btn-errors" (click)="closePopup()">×</button>
              </div>
        </ng-template>
      <ng-template #emptymessage>
        <tr class="no-records">
          <td [attr.colspan]="element?.name === 'queryViewMapping' ? 5 : 3" class="text-center">
            {{ 'NO_RECORDS_FOUND' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div
      *ngIf="
        element.lookupTo === 'parameterMapStdGrid' ||
        element.lookupTo === 'parameterMapHoldValParams' ||
        element.lookupTo === 'detailPageParameters' ||
        element.lookupTo === 'parameterMapStdGridPageVar' ||
        element.lookupTo === 'queryMapPageVar' ||
        element.lookupTo === 'navigatePageParams'
      "
    >
    <div class="outer-border d-flex align-items-start">
          <button type="button" class="btn btn-primary btn-sm px-3" (click)="addParam()" [disabled]="disableField || isFromModernize">{{ btnName | translate }}</button>
        </div>
      <div class="section-table-container param-table">
        <div class="d-flex flex-column">
          <p-table
            [value]="parameterMapping"
            class="fil-map-table"
            [showGridlines]="true"
            [style]="{ width: '100%' }"
            [scrollable]="true"
          >
            <ng-template #header>
              <tr>
                <th>{{ colHeader1 | translate }}</th>
                <th></th>
                <th>
                  <span class="d-flex align-items-center">
                    <span class="mr-2">{{ colHeader2 | translate }}</span>
                    <i
                      class="fa fa-info-circle field-info"
                      showDelay="100"
                      hideDelay="100"
                      *ngIf="element.lookupTo !== 'navigatePageParams'"
                      tooltipPosition="bottom"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltip="{{
                        (element.lookupTo === 'parameterMapStdGridPageVar' || element.lookupTo === 'queryMapPageVar'
                          ? 'PV_FLD_INFO'
                          : 'DET_FLD_INFO'
                        ) | translate
                      }}"
                    ></i>
                  </span>
                </th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-data let-ri="rowIndex">
              <tr>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="autocomplete-wrapper-src">
                    <p-autocomplete
                      [(ngModel)]="data[srcKey]"
                      dataKey="sid"
                      [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                      [suggestions]="srcFlds"
                      (onSelect)="onSrcFieldSel($event.value, data)"
                      trim="blur"
                      appendTo="body"
                      (completeMethod)="showFlds($event, data)"
                      (onClear)="onAutoComValClear(data, srcKey)"
                      [showEmptyMessage]="true"
                      [emptyMessage]="'No records found'"
                      [dropdown]="true"
                      [forceSelection]="true"
                      field="name"
                      placeholder="Select"
                      [showClear]="data[srcKey]"
                      [disabled]="disableField"
                      [group]="
                        element.lookupTo === 'detailPageParameters' ||
                        this.element.lookupTo === 'parameterMapHoldValParams' ||
                        this.element.lookupTo === 'parameterMapStdGrid' ||
                        (this.element.lookupTo === 'navigatePageParams' && this.colHeader1 !== 'VARFRMLST')
                      "
                      showDelay="100"
                      hideDelay="100"
                      tooltipPosition="top"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      panelStyleClass="group-autocomplete"
                      pTooltip="{{ data[srcKey] ? data[srcKey]?.name : null }}"
                      [class.errors-borders]="isParameterMappingSourceFieldNoLonger(data)"
                    >
                      <ng-template let-field pTemplate="item">
                        <div
                          class="field-item text-overflow"
                          [ngClass]="{
                            'item-disabled':
                              !field?.searchable &&
                              techStackData?.textSearch === 'Elastic Search' &&
                              element?.name === 'parameterMapping'
                          }"
                          [class.bor-top]="field?.separator"
                        >
                          <span
                            [ngClass]="{
                              'pl-2':
                                element.lookupTo === 'detailPageParameters' ||
                                this.element.lookupTo === 'parameterMapHoldValParams'
                            }"
                            >{{ field.name }}</span
                          >
                          <span class="search-label font-italic">
                            {{
                              !field.searchable &&
                              techStackData?.textSearch === 'Elastic Search' &&
                              element?.name === 'parameterMapping' &&
                              field?.type !== 'pageVariable'
                                ? ' (NotSearchable) '
                                : ''
                            }}
                            {{
                              !field.indexed &&
                              techStackData?.textSearch !== 'Elastic Search' &&
                              element?.name === 'parameterMapping' &&
                              field?.type !== 'pageVariable'
                                ? ' (Not Indexed) '
                                : ''
                            }}
                          </span>
                        </div>
                      </ng-template>
                      <ng-template let-group #group>
                        <div class="flex align-items-center">
                          <span class="fw-bold">{{ group.name }}</span>
                        </div>
                      </ng-template>
                    </p-autocomplete>
                    <i
                      *ngIf="isParameterMappingSourceFieldNoLonger(data)"
                      class="pi pi-exclamation-circle errors-icon ml-1"
                      (click)="togglePopupsrc(ri, 'error')"
                      (keyup.enter)="togglePopupsrc(ri, 'error')"
                      tabindex="0"
                    ></i>
                    </div>
                  </div>
                </td>
                <td class="arrow-denotation">
                  <i
                    class="pi"
                    [ngClass]="
                      element.lookupTo === 'parameterMapStdGrid' ||
                      element.lookupTo === 'parameterMapStdGridPageVar' ||
                      element.lookupTo === 'queryMapPageVar'
                        ? 'pi-arrow-left'
                        : 'pi-arrow-right'
                    "
                  ></i>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="autocomplete-wrapper">
                    <p-autocomplete
                      [(ngModel)]="data[tarkey]"
                      [disabled]="!data[srcKey] || disableField"
                      dataKey="sid"
                      [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                      [suggestions]="allFieldsFiltered"
                      (onSelect)="onTargetFieldSel($event, data)"
                      trim="blur"
                      appendTo="body"
                      [showEmptyMessage]="showEmptyMsg"
                      [emptyMessage]="'No records found'"
                      (onClear)="onAutoComValClear(data, tarkey)"
                      [showClear]="data[tarkey]"
                      (completeMethod)="showFilterOptsForTarget($event, data[srcKey])"
                      [dropdown]="true"
                      [forceSelection]="true"
                      field="name"
                      placeholder="Select"
                      [group]="
                        (this.element.lookupTo === 'navigatePageParams' && this.colHeader2 !== 'VARTOLST') ||
                        this.element.lookupTo !== 'navigatePageParams'
                      "
                      showDelay="100"
                      hideDelay="100"
                      tooltipPosition="top"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      panelStyleClass="group-autocomplete"
                      pTooltip="{{ data[tarkey] ? data[tarkey]?.name : null }}"
                      [class.warnings-border]="isParameterMappingFieldMismatch(data)"
                      [class.errors-borders]="isParameterMappingTargetFieldNoLonger(data)"
                    >
                      <ng-template let-field pTemplate="item">
                        <div class="field-item text-overflow">
                          <span class="pl-2">{{ field.name }}</span>
                        </div>
                      </ng-template>
                      <ng-template let-group #group>
                        <div class="flex align-items-center">
                          <span class="fw-bold">{{ group.name }}</span>
                        </div>
                      </ng-template>
                    </p-autocomplete>
                    <i
                      *ngIf="isParameterMappingFieldMismatch(data)"
                      class="pi pi-exclamation-triangle warn-icon ml-1"
                      (click)="toggleErrorPopup(ri, 'warning')"
                      (keyup.enter)="toggleErrorPopup(ri, 'warning')"
                      tabindex="0"
                    ></i>
                    <i
                      *ngIf="isParameterMappingTargetFieldNoLonger(data)"
                      class="pi pi-exclamation-circle errors-icon ml-1"
                      (click)="toggleErrorPopup(ri, 'error')"
                      (keyup.enter)="toggleErrorPopup(ri, 'error')"
                      tabindex="0"
                    ></i>
                    <div *ngIf="activePopupIndex === ri && popupType === 'warning'" class="warning-popup">
                      <div class="popup-header">
                        Warning
                      </div>
                      <div class="popup-content">
                        {{ 'FLD_MISMATCH' | translate }}
                      </div>
                      <button class="close-btn" (click)="closePopup()">×</button>
                    </div>
                    <div *ngIf="activePopupIndex === ri && popupType === 'error'" class="warning-popup-errors">
                      <div class="popup-header-errors">
                        Error
                      </div>
                      <div class="popup-content-errors">
                        {{ 'FLD_NO_LONGER' | translate }}
                      </div>
                      <button class="close-btn-errors" (click)="closePopup()">×</button>
                    </div>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <div class="param-actions" *ngIf="!disableField">
                    <svg-icon
                      (click)="openOption(data)"
                      src="assets\images\svg\edit.svg"
                      class="icon-plus cursor-pointer mr-1"
                      alt="edit"
                      aria-hidden="true"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="Edit"
                      tooltipPosition="top"
                      *ngIf="
                        element.lookupTo === 'parameterMapStdGrid' || element.lookupTo === 'parameterMapHoldValParams'
                      "
                    >
                    </svg-icon>
                    <svg-icon
                      (click)="deleteOption(ri)"
                      src="assets\images\svg\trash.svg"
                      class="icon-plus cursor-pointer"
                      alt="delete"
                      aria-hidden="true"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="Delete"
                      tooltipPosition="top"
                    >
                    </svg-icon>
                  </div>
                </td></tr>
                <div *ngIf="activePopupIndexsrc === ri && popupTypesrc === 'error'" class="warning-popup-errors-src">
                  <div class="popup-header-errors">
                    Error
                  </div>
                  <div class="popup-content-errors">
                    {{ 'FLD_NO_LONGER' | translate }}
                  </div>
                  <button class="close-btn-errors" (click)="closePopupsrc()">×</button>
                </div>
              </ng-template>
            <ng-template #emptymessage>
              <tr class="no-records">
                <td colspan="4" class="text-center">
                  {{ 'NO_RECORDS_FOUND' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="{{ 'PARAM_MAP_OPTION' | translate }}"
  [(visible)]="showFilterOptions"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '50vw' }"
  appendTo="body"
  *ngIf="showFilterOptions"
  [closable]="true"
  styleClass="filter-ops-model"
>
  <div class="p-3">
    <div class="d-flex align-items-center mb-2">
      <p-checkbox binary="true" inputId="viewInPages" [(ngModel)]="viewInPages" (onChange)="updateOption($event)">
      </p-checkbox>
      <label class="mb-0 pl-1 pt-0 cursor-pointer opt-lbl" for="viewInPages"
        >{{ 'ALLOW_VIEW_MAP' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'ALLOW_VIEW_INFO_MAP' | translate }}"
        ></i>
      </label>
    </div>
    <div class="d-flex align-items-center mb-2">
      <p-checkbox
        binary="true"
        inputId="holdFilterValue"
        [(ngModel)]="holdFilterValue"
        (onChange)="updateOption($event)"
        [disabled]="holdValDis"
      ></p-checkbox>
      <label class="mb-0 pl-1 pt-0 cursor-pointer opt-lbl" for="holdFilterValue"
        >{{ 'HOLD_VALUE_MAP' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'ALLOW_EDIT_INFO_MAP' | translate }}"
        ></i>
      </label>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="{{ 'QUERY_MAP_OPTION' | translate }}"
  [(visible)]="showQueryFilterOptions"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '50vw' }"
  appendTo="body"
  *ngIf="showQueryFilterOptions"
  [closable]="true"
  styleClass="filter-ops-model"
>
  <div class="p-3">
    <div class="d-flex align-items-center mb-2">
      <p-checkbox
        binary="true"
        inputId="holdFilterValue"
        [(ngModel)]="holdFilterValue"
        (onChange)="updateOption($event)"
        [disabled]="holdValDis"
      ></p-checkbox>
      <label class="mb-0 pl-1 pt-0 cursor-pointer opt-lbl" for="holdFilterValue"
        >{{ 'HOLD_VALUE_MAP' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'ALLOW_EDIT_INFO_MAP' | translate }}"
        ></i>
      </label>
    </div>
  </div>
</p-dialog>
